<template>
    <div v-if="question.value && Object.keys(question['answers'][question.value.answer_id].questions).length">
        <template v-for="child_question in question['answers'][question.value.answer_id].questions">
          <div class="col-md-12">
            <div class='row padding'>
                <div class="col-md-7 mandatory" >
                    <label> {{child_question.name}} </label>
                </div>
                <div class="col-md-5" >
                  <div v-if="child_question.type === 'Combobox' && child_question.sorted_answer_ids.length <= 4">
                    <el-radio-group
                      size="small"
                      value-key="answer_id"
                      :name="'question_'"
                      v-model="child_question.valueHolder"
                      @change="onAnswerChange(child_question)"
                    >
                      <el-radio-button
                        v-for="answer_id in child_question.sorted_answer_ids"
                        class="select-danger"
                        tabindex="0"
                        :key="answer_id"
                        :label="child_question['answers'][answer_id].name"
                        :value="{
                          answer_id: answer_id,
                          answer_name: child_question['answers'][answer_id].name
                        }"
                      >
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <div v-if="child_question.type === 'Combobox' && child_question.sorted_answer_ids.length > 4 ">
                    <el-select size="large"
                                        placeholder="Single Select"
                                        :name="'question_'"
                                        @change="onAnswerChange(child_question)"
                                        filterable
                                        v-model="child_question.valueHolder">
                              <el-option v-for="option in child_question.sorted_answer_ids"
                                        class="select-danger"
                                        :value="child_question['answers'][option].name"
                                        :label="computeCaption(child_question.answers[option].name, this.$store.state.lang.value.toLowerCase())"
                                        :key="option">
                              </el-option>
                    </el-select>
                  </div>
                </div>
              <div class="col-md-5" >
                <div v-if="child_question.type === 'Multichoice'">
                  <el-select size="large"
                    v-model="child_question.multiple"
                    @change="onAnswerChange(child_question)"
                    :name="'question_'"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="Select">
                    <el-option
                      class="select-danger"
                      v-for="answer_id in child_question.sorted_answer_ids"
                      :key="answer_id"
                      :label="computeCaption(child_question['answers'][answer_id].name, this.$store.state.lang.value.toLowerCase())"
                      :value="child_question['answers'][answer_id].name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="child_question.type === 'Combobox' || child_question.type === 'Multichoice'">
              <recursive-question :question="child_question"></recursive-question>
              </div>
              <div class="col-md-5" >
                <div v-if="child_question.type === 'Text'">
                    <el-input
                        type="textarea"
                        name= "Question"
                        autosize
                        class="w-100"
                        @input="onAnswerChange(child_question)"
                        v-model="child_question.value">
                    </el-input>
                </div>
                <div v-if="child_question.type === 'Number'">
                    <el-input
                        type="number"
                        inputmode="numeric"
                        name= "Question"
                        autosize
                        class="w-100"
                        @input="onAnswerChange(child_question)"
                        v-model="child_question.value">
                    </el-input>
                </div>
              </div>
              <div class="col-md-5" >
                <div v-if="child_question.type === 'Date'">
                  <el-date-picker
                        v-model="child_question.value"
                        type="date"
                        class="w-100"
                        format="MM/dd/yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="Select date">
                    </el-date-picker>
                </div>
              </div>
            </div>
          </div>
        </template>

    </div>

</template>

<script>
    import {Button, RadioGroup, Radio, RadioButton, DatePicker, Input} from 'element-ui'
    import {TranslationsUtils} from '../../../../../utils/Translations'
    export default {
      name: 'RecursiveQuestion',
      components: {
        [Input.name]: Input,
        [DatePicker.name]: DatePicker,
        [Button.name]: Button,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [RadioButton.name]: RadioButton },
      mixins: [TranslationsUtils],
      props: ['question'],
      methods: {
        onAnswerChange (question) {
          let id
          for (id in question.answers) {
            if (question.answers[id].name === question.valueHolder) {
              question.value = {answer_id: question.answers[id].id, answer_name: question.answers[id].name}
            }
          }
          question.valid = !!question.value
        }
      }
    }
</script>

<style scoped>
  .padding {
    padding-top: 1vh;
  }

  .w-100{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/RecursiveQuestions.vue